import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, friendlyError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password aggiornata. Accedi con la nuova password.");
      navigate("/login");
    } catch (err) { toast.error(friendlyError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--ri-bg)] p-6">
      <div className="w-full max-w-sm bg-white rounded-xl border border-slate-200 p-8">
        <div className="ri-overline mb-2">RegIntel CDMO</div>
        <h1 className="font-head text-2xl font-bold mb-1">Reimposta la password</h1>
        {!token ? (
          <p className="text-sm text-red-600 mt-3">Link non valido o mancante. Richiedi un nuovo link dalla pagina di accesso.</p>
        ) : (
          <form onSubmit={submit} className="space-y-3 mt-4">
            <input type="password" required placeholder="Nuova password (min 8 caratteri)" data-testid="reset-password-input"
              value={pw} onChange={(e) => setPw(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
            <input type="password" required placeholder="Conferma password" data-testid="reset-password-confirm"
              value={pw2} onChange={(e) => setPw2(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
            <button type="submit" disabled={busy} data-testid="reset-submit-btn"
              className="w-full py-2.5 rounded-lg bg-blue-700 text-white font-medium hover:bg-blue-800 disabled:opacity-60">
              {busy ? "Attendere..." : "Aggiorna password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
